import { type Msg } from '@halo/chat-sdk-react';
import { MessageFooter } from '@halo/ui-chat-react';
import { useIsMyMsg } from '@/scripts/hooks';

// Message
export interface MsgFooterProps {
  message: Msg;
  children: React.ReactNode;
}

export const MsgFooter = memo(function MsgFooter({ message, children }: MsgFooterProps) {
  const isMyMessage = useIsMyMsg(message);

  return <MessageFooter isMe={isMyMessage}>{children}</MessageFooter>;
});
